import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  return (
    <Link
      to={`/article/${comic.id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={comic.cover}
          alt={`${comic.title} - 韩漫屋免费在线韩漫`}
          title={`${comic.title} - 免费韩国漫画在线阅读`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 right-2">
          <span
            className={`px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
              comic.status === '连载中'
                ? 'bg-primary-500 text-background-50'
                : 'bg-secondary-500 text-background-50'
            }`}
          >
            {comic.status}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
          <div className="flex items-center gap-1 text-background-50 text-xs">
            <i className="ri-star-fill text-accent-300 w-3 h-3 flex items-center justify-center"></i>
            <span>{comic.rating}</span>
            <span className="mx-1 text-background-50/40">|</span>
            <i className="ri-eye-line w-3 h-3 flex items-center justify-center"></i>
            <span>{(comic.views / 10000).toFixed(1)}万</span>
          </div>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-1">
          {comic.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500">{comic.author}</p>
        <div className="mt-2 flex flex-wrap gap-1">
          {comic.tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="px-1.5 py-0.5 text-[10px] rounded bg-accent-100 text-accent-700 whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}